import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { ViewedHints } from '../../../typings';

export function postSetViewedHints(hintData: ViewedHints): Promise<ViewedHints> {
    const { apiPostSetViewedHints } = apiConfig.getStaticUrls();

    return postFetch(apiPostSetViewedHints, { hintData });
}
